// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
nav.navbar {
  padding: 18px 0;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 9999;
  transition: 0.32s ease-in-out;
}

nav.navbar.scrolled {
  padding: 0px 0;
  background-color: var(--green);
}

nav.navbar a.navbar-brand {
  width: 9%;
}

nav.navbar .navbar-nav .nav-link.navbar-link {
  font-weight: 400;
  color: var(--dark-green) !important;
  letter-spacing: 0.8px;
  padding: 0 25px;
  font-size: 18px;
  opacity: 0.75;
}

nav.navbar .navbar-nav a.nav-link.navbar-link:hover,
nav.navbar .navbar-nav a.nav-link.navbar-link.active {
  opacity: 1;
}

span.navbar-text {
  display: flex;
  align-items: center;
}

.social-icon {
  display: inline-block;
  margin-left: 14px;
}
.social-icon a {
  width: 42px;
  height: 42px;
  background: rgba(217, 217, 217, 0.1);
  display: inline-flex;
  border-radius: 50%;
  margin-right: 6px;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

.social-icon a::before {
  content: "";
  width: 42px;
  height: 42px;
  position: absolute;
  background-color: #ffffff;
  border-radius: 50%;
  transform: scale(0);
  transition: 0.3s ease-in-out;
}

.social-icon a:hover::before {
  transform: scale(1);
}

.social-icon a img {
  width: 40%;
  z-index: 1;
  transition: 0.3s ease-in-out;
}

.social-icon a:hover img {
  filter: brightness(0) saturate(100%) invert(0%) sepia(7%) saturate(98%) hue-rotate(346deg) brightness(95%)
    contrast(86%);
}

.language-switch {
  display: inline-block;
  margin-left: 14px;
}

.navbar-text button {
  font-weight: 700;
  color: var(--dark-green);
  border: 1px solid var(--dark-green);
  padding: 18px 34px;
  font-size: 18px;
  margin-left: 18px;
  position: relative;
  background-color: transparent;
  transition: 0.3s ease-in-out;
}

.navbar-text button span {
  z-index: 1;
}

.navbar-text button::before {
  content: "";
  width: 0%;
  height: 100%;
  position: absolute;
  background-color: var(--green);
  left: 0;
  top: 0;
  z-index: -1;
  transition: 0.3s ease-in-out;
}

.navbar-text button:hover {
  color: #fff;
}

.navbar-text button:hover::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
}

nav.navbar .navbar-toggler:active,
nav.navbar .navbar-toggler:focus {
  outline: none;
  box-shadow: none;
}

nav.navbar .navbar-toggler-icon {
  width: 24px;
  height: 17px;
  background-image: none;
  position: relative;
  border-bottom: 2px solid #fff;
  transition: all 300ms linear;
  top: -2px;
}

nav.navbar .navbar-toggler-icon:focus {
  border-bottom: 2px solid #fff;
}

nav.navbar .navbar-toggler-icon:after,
nav.navbar .navbar-toggler-icon:before {
  width: 24px;
  position: absolute;
  height: 2px;
  background-color: #fff;
  top: 0;
  left: 0;
  content: "";
  z-index: 2;
  transition: all 300ms linear;
}

nav.navbar .navbar-toggler-icon:after {
  top: 8px;
}

nav.navbar .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:after {
  transform: rotate(45deg);
  background-color: #fff;
  height: 2px;
}

nav.navbar .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:before {
  transform: translateY(8px) rotate(-45deg);
  background-color: #fff;
  height: 2px;
}

nav.navbar .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon {
  border-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./packages/studytour-io-app/src/components/NavBar.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE;iBACe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,OAAO;EACP,MAAM;EACN,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/**\n * Copyright 2025 Paion Data. All rights reserved.\n */\nnav.navbar {\n  padding: 18px 0;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 9999;\n  transition: 0.32s ease-in-out;\n}\n\nnav.navbar.scrolled {\n  padding: 0px 0;\n  background-color: var(--green);\n}\n\nnav.navbar a.navbar-brand {\n  width: 9%;\n}\n\nnav.navbar .navbar-nav .nav-link.navbar-link {\n  font-weight: 400;\n  color: var(--dark-green) !important;\n  letter-spacing: 0.8px;\n  padding: 0 25px;\n  font-size: 18px;\n  opacity: 0.75;\n}\n\nnav.navbar .navbar-nav a.nav-link.navbar-link:hover,\nnav.navbar .navbar-nav a.nav-link.navbar-link.active {\n  opacity: 1;\n}\n\nspan.navbar-text {\n  display: flex;\n  align-items: center;\n}\n\n.social-icon {\n  display: inline-block;\n  margin-left: 14px;\n}\n.social-icon a {\n  width: 42px;\n  height: 42px;\n  background: rgba(217, 217, 217, 0.1);\n  display: inline-flex;\n  border-radius: 50%;\n  margin-right: 6px;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n}\n\n.social-icon a::before {\n  content: \"\";\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  background-color: #ffffff;\n  border-radius: 50%;\n  transform: scale(0);\n  transition: 0.3s ease-in-out;\n}\n\n.social-icon a:hover::before {\n  transform: scale(1);\n}\n\n.social-icon a img {\n  width: 40%;\n  z-index: 1;\n  transition: 0.3s ease-in-out;\n}\n\n.social-icon a:hover img {\n  filter: brightness(0) saturate(100%) invert(0%) sepia(7%) saturate(98%) hue-rotate(346deg) brightness(95%)\n    contrast(86%);\n}\n\n.language-switch {\n  display: inline-block;\n  margin-left: 14px;\n}\n\n.navbar-text button {\n  font-weight: 700;\n  color: var(--dark-green);\n  border: 1px solid var(--dark-green);\n  padding: 18px 34px;\n  font-size: 18px;\n  margin-left: 18px;\n  position: relative;\n  background-color: transparent;\n  transition: 0.3s ease-in-out;\n}\n\n.navbar-text button span {\n  z-index: 1;\n}\n\n.navbar-text button::before {\n  content: \"\";\n  width: 0%;\n  height: 100%;\n  position: absolute;\n  background-color: var(--green);\n  left: 0;\n  top: 0;\n  z-index: -1;\n  transition: 0.3s ease-in-out;\n}\n\n.navbar-text button:hover {\n  color: #fff;\n}\n\n.navbar-text button:hover::before {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n\nnav.navbar .navbar-toggler:active,\nnav.navbar .navbar-toggler:focus {\n  outline: none;\n  box-shadow: none;\n}\n\nnav.navbar .navbar-toggler-icon {\n  width: 24px;\n  height: 17px;\n  background-image: none;\n  position: relative;\n  border-bottom: 2px solid #fff;\n  transition: all 300ms linear;\n  top: -2px;\n}\n\nnav.navbar .navbar-toggler-icon:focus {\n  border-bottom: 2px solid #fff;\n}\n\nnav.navbar .navbar-toggler-icon:after,\nnav.navbar .navbar-toggler-icon:before {\n  width: 24px;\n  position: absolute;\n  height: 2px;\n  background-color: #fff;\n  top: 0;\n  left: 0;\n  content: \"\";\n  z-index: 2;\n  transition: all 300ms linear;\n}\n\nnav.navbar .navbar-toggler-icon:after {\n  top: 8px;\n}\n\nnav.navbar .navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon:after {\n  transform: rotate(45deg);\n  background-color: #fff;\n  height: 2px;\n}\n\nnav.navbar .navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon:before {\n  transform: translateY(8px) rotate(-45deg);\n  background-color: #fff;\n  height: 2px;\n}\n\nnav.navbar .navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon {\n  border-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
